module.exports = __webpack_public_path__ + "img/cloudpod_logo.e4f7ce9e.png";